import { IS_TAURI } from '../browser/globalEnvironment';

// Whether the desktop window is in front, as reported by the shell rather than by the document.
//
// `document.hasFocus()` is what gates every notification: a banner is only raised when the window is
// NOT focused. Inside the shell's WKWebView that call can keep answering `true` while the window sits
// in the background, and the gate then suppresses every banner — the desktop app looked like it had
// no notifications at all. The shell knows the real state and emits `tauri://focus` / `tauri://blur`
// for it, so prefer those.
//
// Deliberately event-only. Seeding this from `getCurrentWindow().isFocused()` would be the obvious
// start, but that is a gated command and `removeUnusedCommands` strips anything the capability file
// does not grant — so it would need a new desktop build, while listening ships with a web deploy.
let isShellWindowFocused: boolean | undefined;

export function trackTauriWindowFocus() {
  if (!IS_TAURI) return;

  void import('@tauri-apps/api/event').then(({ listen, TauriEvent }) => {
    void listen(TauriEvent.WINDOW_FOCUS, () => {
      isShellWindowFocused = true;
    });
    void listen(TauriEvent.WINDOW_BLUR, () => {
      isShellWindowFocused = false;
    });
  });
}

/** Is the app in front? Use instead of `document.hasFocus()` wherever the desktop shell must agree. */
export default function getIsAppFocused() {
  // Before the shell has reported anything there is nothing better than the document's own answer,
  // and a window that just opened is focused regardless.
  if (IS_TAURI && isShellWindowFocused !== undefined) {
    return isShellWindowFocused;
  }

  return document.hasFocus();
}
